import actions from './actions'

export default function PartOrdersReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_PARTORDER:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_PARTORDER:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_PARTORDER:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_PARTORDER:
      return {
        ...state,
        editing: { partOrderID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_PARTORDER_RECIEVED ||
      actions.UPDATE_PARTORDER_RECIEVED ||
      actions.DELETE_PARTORDER_RECIEVED:
      return {
        ...state,
        editing: { partOrderID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
